// extracted by mini-css-extract-plugin
export var icon = "price-large-module--icon--HRUZQ";
export var wrapper = "price-large-module--wrapper--Ts09W";